export default function addSoftHyphenation(text, minLength = 0) {
  var RusA = '[абвгдеёжзийклмнопрстуфхцчшщъыьэюя]'
  var RusV = '[аеёиоуыэюя]'
  var RusN = '[бвгджзклмнпрстфхцчшщ]'
  var RusX = '[йъь]'
  var Hyphen = '\u00AD'
  var re1 = new RegExp('(' + RusX + ')(' + RusA + RusA + ')', 'ig')
  var re2 = new RegExp('(' + RusV + ')(' + RusV + RusA + ')', 'ig')
  var re3 = new RegExp('(' + RusV + RusN + ')(' + RusN + RusV + ')', 'ig')
  var re4 = new RegExp('(' + RusN + RusV + ')(' + RusN + RusV + ')', 'ig')
  var re5 = new RegExp('(' + RusV + RusN + ')(' + RusN + RusN + RusV + ')', 'ig')
  var re6 = new RegExp('(' + RusV + RusN + RusN + ')(' + RusN + RusN + RusV + ')', 'ig')
  const words = text.split(' ')
  const replacesWords = words.map(word => {
    const wordParts = word.split('-')
    const replacedParts = wordParts.map(part => {
      if (part.length >= minLength) {
        part = part.replace(re1, '$1' + Hyphen + '$2')
        part = part.replace(re2, '$1' + Hyphen + '$2')
        part = part.replace(re3, '$1' + Hyphen + '$2')
        part = part.replace(re4, '$1' + Hyphen + '$2')
        part = part.replace(re5, '$1' + Hyphen + '$2')
        part = part.replace(re6, '$1' + Hyphen + '$2')
      }
      return part
    })
    return replacedParts.join('-')
  })
  return replacesWords.join(' ')
}
